<template>
  <section class="c-missioncontainer">
    <div class="container">
      <div class="c-missioncontainer__header">
        <h1 class="c-missioncontainer__title">{{$t('homepage.mission-container.title')}}</h1>
        <h2 class="c-missioncontainer__subtitle">{{$t('homepage.mission-container.subtitle')}}</h2>
      </div>
      <div class="c-missioncontainer__content">
        <div class="row">
          <template v-for="(mission, index) in actions">
            <Mission
              v-bind:key="index"
              :title="mission.title"
              :points="mission.points"
              :type="mission.type"
            ></Mission>
          </template>
        </div>
      </div>
      <div class="c-missioncontainer__register__container">
        <h1 class="c-missioncontainer__register__text">{{$t('homepage.mission-container.register')}}</h1>
        <div class="c-missioncontainer__register__button">
          <button
            class="btn register-button"
            @click="scrollToTop()"
          >{{$t('homepage.mission-container.register-button')}}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mission from "./Mission";
export default {
  props: ["actions"],
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  components: {
    Mission
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.c-missioncontainer {
  padding-top: 3rem;
  padding-bottom: 3rem;
  background: url("/static/tempAssets/fir-container-background-mobile.png") no-repeat center center;
  background-size: cover;
  background-position: right;
  @include lg {
    padding-bottom: 5rem;
    background: none;
  }
}

.c-missioncontainer__header {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: white;
  @include lg {
    text-align: left;
  }

  h1 {
    font-size: 34px;
    font-weight: 700;
    margin-bottom: 1rem;
    @include lg {
      font-size: 45px;
    }
  }

  h2 {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.17;
    letter-spacing: 1px;
    @include lg {
      font-size: 30px;
    }
  }
}

.c-missioncontainer__content {
  margin-top: 2rem;
}
.c-missioncontainer__register__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 0 0;
  @include lg {
    text-align: left;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.c-missioncontainer__register__text {
  color: white;
  font-weight: 700;
  font-size: 34px;
  letter-spacing: 2px;
  @include lg {
    max-width: 45%;
  }
}
.c-missioncontainer__register__button {
  margin: 2rem 0;
  color: #000;
  @include lg {
    max-width: 40%;
    margin: 0;
  }
}
.btn.register-button {
  border: 1px solid #fff;
  background-color: #0058A2;
  color: white;
  border-radius: 5px;
  font-weight: 700;
  padding: 18px 58px 18px 58px;
  cursor: pointer;
}
.btn.register-button:hover {
  border: 1px solid white;
  background-color: white;
  color: #0058A2;
}
</style>